export const licenseKey = 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImZhMGEwYjJjLTEwZjctNDk2Ny05OWU5LWMwNDhjOWQyMzYxNiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUxCn0=.HF27CTEXRDOx/QBVUHURYJO4pdhlZs9TdsnaiIJDoakZKfeSU0stsujPDXDG3vnY4NYWytLjDAOG3yWCrceZsOCLUy32blORhMY6wHB8eWHaP5m03SAb56907sPfn4Mk4jH2eg==';


